export const CHECKOUT_URL = "https://foot-en.impultienda.ar/checkout/";

export const PRICE = 27;
export const TOTAL_VALUE = 142;

export const images = {
  mockup: "https://cdn.magicpatterns.com/uploads/2BAGRaPZagbtY4s2SSb8Gy/MOCKUP_FOOT-N.png",
  author: "https://cdn.magicpatterns.com/uploads/r2DtorbPhGASBBjH84WfZe/RYAN_CARTER_-_SPINE.png",
};
